import { render, staticRenderFns } from "./service-qualityreport.vue?vue&type=template&id=38d8d098&"
import script from "./service-qualityreport.vue?vue&type=script&lang=js&"
export * from "./service-qualityreport.vue?vue&type=script&lang=js&"
import style0 from "./service-qualityreport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports